import { render, staticRenderFns } from "./CreateRoomError.vue?vue&type=template&id=3d352c24&scoped=true"
import script from "./CreateRoomError.vue?vue&type=script&lang=ts"
export * from "./CreateRoomError.vue?vue&type=script&lang=ts"
import style0 from "./CreateRoomError.vue?vue&type=style&index=0&id=3d352c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d352c24",
  null
  
)

export default component.exports